const f = {
  color: {
    toggle: {
      bg: "#fff",
      boxShadow: "rgba(0, 0, 0, 0.1)"
    },
    backdrop: {
      bg: {
        default: "#c8d3deff",
        hover: "#abb9c7ff",
        hoverChecked: "#2d8556ff",
        disabled: "#f1f3f5ff",
        checked: "#47c47dff"
      },
      color: {
        default: "#7e8e9eff",
        disabled: "#556575ff",
        checked: "#fff",
        checkedDisabled: "#556575ff"
      }
    },
    state: {
      error: {
        boxShadow1: "#fff",
        boxShadow2: "#e54a32ff",
        boxShadow3: "#fedfd5ff"
      }
    }
  }
};
export {
  f as switchComponent
};
